import { Link } from 'react-router-dom'

import Button from '../../components/form/Button'
import CheckedIcon from '../../../assets/icons/checked.svg?react'
import { useI18N } from '../../../libraries/i18n/hook'

const AlreadyBoughtPage = () => {
  const { t } = useI18N()
  return (
    <div className='flex flex-col items-center justify-center gap-y-8'>
      <div className='flex flex-col items-center justify-center gap-y-4'>
        <p className='mt-4 flex items-center gap-x-4 whitespace-pre-line'><CheckedIcon className='w-8 h-8 stroke-deep-green' />{t('checkout.already.bought')}</p>
        <p className='flex items-center gap-x-4 whitespace-pre-line'>{t('checkout.already.bought.explanation')}</p>
      </div>
      <Button><Link to='/'>{t('common.go.home')}</Link></Button>
    </div>
  )
}

export default AlreadyBoughtPage
